import { generateTimesheets } from '@/__fixtures__/timesheets.dynamic';
import { ActivityType, OnCallDutyType, Timesheet, TimesheetStatus } from '@/shared/types/timesheet';

export const timesheets = generateTimesheets({
  userId: '23456',
  contractStart: new Date('2025-01-13'),
  contractEnd: new Date('2025-12-24'),
  projectName: 'Optim.Net - CACIB',
  // Rattache la ligne projet des CRA historiques à la mission Optim.Net (voir missions.mock).
  missionId: 'mission-optim-net',
  includeNonBillable: true,
  includeAlsaceMoselleHolidays: false,
});

export const timesheetsBis: Timesheet[] = [
  {
    id: '1',
    userId: '23456',
    year: 2025,
    month: 1,
    timesheetStatus: TimesheetStatus.VALIDATED,
    workingDays: 14,
    totalWorkedDays: 14,
    totalRemoteWorkDays: 4,
    totalAbsenceDays: 0,
    hasOnCallDuty: false,
    activities: [
      {
        id: '1',
        type: ActivityType.PROJECT,
        name: 'Optim.Net - CACIB',
        daysWork: {
          '2025-01-14': 1,
          '2025-01-15': 1,
          '2025-01-16': 1,
          '2025-01-17': 1,
          '2025-01-20': 1,
          '2025-01-21': 1,
          '2025-01-22': 1,
          '2025-01-23': 1,
          '2025-01-24': 1,
          '2025-01-27': 1,
          '2025-01-28': 1,
          '2025-01-29': 1,
          '2025-01-30': 1,
          '2025-01-31': 1,
        },
        remoteWorkDays: {
          '2025-01-14': true,
          '2025-01-15': true,
          '2025-01-16': true,
          '2025-01-17': true,
        },
      },
    ],
    comment: "J'ai commencé la mission ce mois le 14 et j'étais en full TT la premiere semaine",
  },
  {
    id: '2',
    userId: '23456',
    year: 2025,
    month: 2,
    timesheetStatus: TimesheetStatus.VALIDATED,
    workingDays: 20,
    totalWorkedDays: 15,
    totalRemoteWorkDays: 0,
    totalAbsenceDays: 5,
    hasOnCallDuty: false,
    activities: [
      {
        id: '1',
        type: ActivityType.PROJECT,
        name: 'Optim.Net - CACIB',
        daysWork: {
          '2025-02-03': 1,
          '2025-02-04': 1,
          '2025-02-05': 1,
          '2025-02-06': 1,
          '2025-02-07': 1,
          '2025-02-10': 1,
          '2025-02-11': 1,
          '2025-02-12': 1,
          '2025-02-20': 1,
          '2025-02-21': 1,
          '2025-02-24': 1,
          '2025-02-25': 1,
          '2025-02-26': 1,
          '2025-02-27': 1,
          '2025-02-28': 1,
        },
        remoteWorkDays: {},
      },
      {
        id: '2',
        type: ActivityType.ABSENCE_JUSTIFIED,
        name: 'Jour non facturé',
        daysWork: {
          '2025-02-13': 1,
          '2025-02-14': 1,
        },
        remoteWorkDays: {},
      },
      {
        id: '3',
        type: ActivityType.ABSENCE_TO_BE_JUSTIFIED,
        name: 'Absence - 3 jours pour naissance',
        daysWork: {
          '2025-02-17': 1,
          '2025-02-18': 1,
          '2025-02-19': 1,
        },
        remoteWorkDays: {},
      },
    ],
    comment: '',
  },
  {
    id: '3',
    userId: '23456',
    year: 2025,
    month: 3,
    timesheetStatus: TimesheetStatus.SUBMITTED,
    workingDays: 21,
    totalWorkedDays: 21,
    totalRemoteWorkDays: 0,
    totalAbsenceDays: 0,
    hasOnCallDuty: false,
    activities: [
      {
        id: '1',
        type: ActivityType.PROJECT,
        name: 'Optim.Net - CACIB',
        daysWork: {
          '2025-03-03': 1,
          '2025-03-04': 1,
          '2025-03-05': 1,
          '2025-03-06': 1,
          '2025-03-07': 1,
          '2025-03-10': 1,
          '2025-03-11': 1,
          '2025-03-12': 1,
          '2025-03-13': 1,
          '2025-03-14': 1,
          '2025-03-17': 1,
          '2025-03-18': 1,
          '2025-03-19': 1,
          '2025-03-20': 1,
          '2025-03-21': 1,
          '2025-03-24': 1,
          '2025-03-25': 1,
          '2025-03-26': 1,
          '2025-03-27': 1,
          '2025-03-28': 1,
          '2025-03-31': 1,
        },
        remoteWorkDays: {},
      },
    ],
    comment: '',
  },
  {
    id: '4',
    userId: '23456',
    year: 2025,
    month: 4,
    timesheetStatus: TimesheetStatus.COMPLETED,
    workingDays: 22,
    totalWorkedDays: 22,
    totalRemoteWorkDays: 0,
    totalAbsenceDays: 0,
    hasOnCallDuty: true,
    activities: [
      {
        id: '1',
        type: ActivityType.PROJECT,
        name: 'Optim.Net - CACIB',
        daysWork: {
          '2025-04-01': 1,
          '2025-04-02': 1,
          '2025-04-03': 1,
          '2025-04-04': 1,
          '2025-04-07': 1,
          '2025-04-08': 1,
          '2025-04-09': 1,
          '2025-04-10': 1,
          '2025-04-11': 1,
          '2025-04-14': 1,
          '2025-04-15': 1,
          '2025-04-16': 1,
          '2025-04-17': 1,
          '2025-04-18': 1,
          '2025-04-21': 1,
          '2025-04-22': 1,
          '2025-04-23': 1,
          '2025-04-24': 1,
          '2025-04-25': 1,
          '2025-04-28': 1,
          '2025-04-29': 1,
          '2025-04-30': 1,
        },
        remoteWorkDays: {},
        onCallDuties: [
          {
            id: 'oc1',
            date: '2025-04-10',
            startTime: '18:00',
            endTime: '22:00',
            crossMidnight: false,
            minutes: 240,
            type: OnCallDutyType.HNO,
            comments: 'Astreinte de soirée',
          },
          {
            id: 'oc2',
            date: '2025-04-15',
            startTime: '22:00',
            endTime: '02:00',
            crossMidnight: true,
            minutes: 240, // 2h (22h-24h) + 2h (00h-02h)
            type: OnCallDutyType.Astreinte,
            comments: 'Astreinte de nuit',
          },
        ],
      },
    ],
    comment: '',
  },
];
